import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import './TicketSidebar.css';
import * as vtex from '../api/vtex';
import zafClient, { openModal, deserializeFields, setTicketCustomFieldSidebar } from '../api/zendesk'
import Settings from '../assets/setting.png'
import OrderInfo from '../components/OrderInfo';
import Loading from '../components/Loading';
import { getObjectItemByPath } from '../utils';

export function formatNumber(value) {
  if (typeof value !== 'number' || isNaN(value)) {
    return value;
  }
  return Number(value/100).toLocaleString('pt-BR')
}

export default function TicketSidebar() {
  const [searchBar, setSearchBar] = useState('')
  const [orders, setOrders] = useState([])
  const [currentCompleteOrder, setCurrentCompleteOrder] = useState(null)
  const [custumer, setCustumer] = useState({})
  const [vtexZendeskMap, setVtexZendeskMap] = useState({})
  const [loading, setLoading] = useState(true)
  const initialRender = useRef(true)

  function openModalUp() {
    openModal('config', { width: '1000px', height: '500px' }, null, loadZendesk)
  }

  async function loadZendesk() {
    setVtexZendeskMap(await deserializeFields())
  }
  
  async function fillZendeskFields(order) {
    const map = await deserializeFields()

    for (const [key, fieldId] of Object.entries(map)) {
      if (fieldId) {
        let value = ''
        if (key.includes('.')) {
          value = getObjectItemByPath(order, key)
        } else {
          value = order[key]
        }
        const formattedValue = formatNumber(value);
        setTicketCustomFieldSidebar(fieldId, formattedValue)
      }
    }
  }

  useEffect(() => {

    zafClient.invoke('resize', { width: '100%', height: '100vh' })

    zafClient.get('ticket.requester.email').then(resp => {
      loadOrders(resp['ticket.requester.email'])
    })
  }, [])
  useEffect(() => {
    const timer = setTimeout(() => {
      if (initialRender.current) {
        initialRender.current = false

      }
      else {
        loadOrders(searchBar)
      }
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [searchBar])

  async function loadOrders(q, showIncompleteOrder = false) {
    setLoading(true)
    try {
      const resp = await vtex.getOrders(q, showIncompleteOrder)
      if (searchBar === '') {
        setOrders([])
      } else {
        const list = resp.list
        if (list.length) {
          const { clientProfileData: { document: cpf, email, firstName, lastName, phone } } = await vtex.getOrder(list[0]['orderId'])
          setCustumer({ fullName: `${firstName} ${lastName}`, cpf, email, phone })
        }
        setOrders(list)
      }
    } finally {
      setLoading(false)
    }
  }

  async function handleOrderClick(order) {
    openModal('modal', { width: '80vw', height: '80vh' }, order.orderId)
  }

  function search(e) {
    setSearchBar(e.target.value)
    if (e.target.value?.length === 0) {
      setCustumer()
    }
  }

  function Troca(e) {
    loadOrders(searchBar, e.target.checked)
  }
  
  useEffect(() => {

    deserializeFields().then(setVtexZendeskMap)
  }, [])

  return (

    <div className='container-sidebar'>

      <div className="switch__containerSide">
        <input onClick={Troca} id="switch-shadow" class="switch switch--shadow" type="checkbox" />
        <label for="switch-shadow"></label>
        <i class="fa fa-arrow-right" aria-hidden="true"></i>

      </div>
      <span className="msgbtn-incompleteOrdersSide">
        <strong>Clique aqui para consultar por</strong> <br /><strong>
          Não faturados/ Incompletos</strong></span>
      <div className="Header">
        <img className="logo" src="https://upload.wikimedia.org/wikipedia/commons/a/a9/VTEX_Logo.svg" alt='logo vtex'/>
        <form>
          <input className="search" type="text" placeholder="Buscar..."
            value={searchBar} onChange={search} onKeyDown={(e) => { e.key === 'Enter' && e.preventDefault() }} />
        </form>
      </div >

      {loading ? <Loading /> : <>
      <div className="content-user-data">
        <p className="cud-p"> Dados do Usuário </p>
      </div>

      <div className="cud-div">
        <div className="cud-list">
          <p className="name p-data" id="name"><strong>Nome:</strong> {custumer?.fullName}</p>
          <p className="cpf p-data" id="cpf"><strong>CPF:</strong> {custumer?.cpf}</p>
          <p className="tel p-data" id="tel"><strong>Telefone:</strong> {custumer?.phone}</p>
        </div>
      </div>

      <div className="content-recent-orders">
        <p> Últimos Pedidos </p>
        <button onClick={openModalUp} ><img src={Settings} alt='Engrenagem para abrir o modal'/></button>
      </div>

      <div className='dropdown'>
        {orders.map(incompleteOrder => 
            <OrderInfo 
                order={
                  currentCompleteOrder?.orderId === incompleteOrder.orderId 
                    ? currentCompleteOrder 
                    : incompleteOrder
                }
                onShowDetails={handleOrderClick}
                onApplyData={order => fillZendeskFields(order, order.sequence)}
                vtexZendeskMap={vtexZendeskMap}
                onSelect={incompleteOrder => {
                    vtex.getOrder(incompleteOrder.orderId).then(setCurrentCompleteOrder)
                }}
            />
        )}
      </div>
      </>}
    </div>
  )
}
